
// Action: file_editor create /app/frontend/src/components/Header.js --file-text 
import React, { useState, useEffect } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png'

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'HOME', path: '/' },
    { name: 'ABOUT', path: '/about' },
    { name: 'OUR WORK', path: '/portfolio' },
    { name: 'TESTIMONIALS', path: '/testimonials' },
    { name: 'CONTACT', path: '/contact' }
  ];

  return (
    <header
      data-testid="main-header"
      className={`w-full transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md'
          : 'bg-transparent'
      }`}
    >
      {/* <img src={logo} alt="Logo" className="h-10 w-auto" /> */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img src={logo} alt="Shree Ram Interior" className="h-24 w-auto cursor-pointer" />
            <Link to="/" data-testid="logo-link" className="flex-shrink-0"></Link>
          </div>
          <Link to="/" data-testid="logo-link" className="flex-shrink-0">
            <h1 className="font-playfair text-2xl md:text-3xl font-bold text-[#1A1A1A]">
              Shree Ram Interior
            </h1>
            <p className="font-manrope text-xs tracking-widest text-[#8C8C8C]">
              & GLASS WORKS
            </p>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.name}
                to={link.path}
                data-testid={`nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                className={`font-manrope text-sm tracking-widest transition-colors duration-300 ${
                  location.pathname === link.path
                    ? 'text-[#D4AF37]'
                    : 'text-[#1A1A1A] hover:text-[#D4AF37]'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </nav>

          {/* CTA Button */}
          <a
            href="tel:+919876543210"
            data-testid="cta-call-button"
            className="hidden lg:flex items-center gap-2 border-2 border-[#D4AF37] text-[#1A1A1A] px-6 py-3 rounded-full hover:bg-[#D4AF37] hover:text-white transition-all duration-300"
          >
            <Phone size={18} />
            <span className="font-manrope font-medium">Call Us</span>
          </a>

          {/* Mobile Menu Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-[#1A1A1A] p-2"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <nav data-testid="mobile-menu" className="lg:hidden mt-6 pb-6 border-t border-[#E5E5E5] pt-6">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.path}
                  data-testid={`mobile-nav-link-${link.name.toLowerCase().replace(' ', '-')}`}
                  onClick={() => setIsMobileMenuOpen(false)}
                  className={`font-manrope text-sm tracking-widest transition-colors duration-300 ${
                    location.pathname === link.path
                      ? 'text-[#D4AF37]'
                      : 'text-[#1A1A1A] hover:text-[#D4AF37]'
                  }`}
                >
                  {link.name}
                </Link>
              ))}
              <a
                href="tel:+919599173367"
                data-testid="mobile-cta-call-button"
                className="flex items-center justify-center gap-2 border-2 border-[#D4AF37] text-[#1A1A1A] px-6 py-3 rounded-full hover:bg-[#D4AF37] hover:text-white transition-all duration-300 mt-2"
              >
                <Phone size={18} />
                <span className="font-manrope font-medium">Call Us</span>
              </a>
            </div>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;

// Observation: Create successful: /app/frontend/src/components/Header.js